import React, {useEffect, useLayoutEffect} from 'react';
import {View} from 'react-native';
import {Text} from '../../../../shared/components/text';
import Screen from '../../../../shared/components/screen';
import {useStyles} from '../../../../shared/hooks/styles';
import {useDispatch, useSelector} from 'react-redux';

import {Breadcrumbs} from '../../../../shared/components/breadcrumbs';
import {CustomScrollView} from '../../../../shared/components/scrollView';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {Routes, Screens} from '../../../../shared/routing';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {DesktopView} from './exchangeHistory/DesktopView';
import {MobileView} from './exchangeHistory/MobileView';
import {molodayaArcticaLoadingSelector, molodayaArcticaSelector} from '../../../../redux/selectors/molodayaArctica';
import {getMolodayaArcticaData} from '../../../../redux/actions/molodayaArctica';
import {images} from '../../../../assets/icons';
import {Button} from '../../../../shared/components/button';
import {defaults} from '../../../../shared/constants/defaults';
import {usePartialList} from '../../../../shared/hooks/usePartialList';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Волонтерство',
    routeName: Screens.VolunteersService,
    webRoute: Routes.volunteersService,
  },
  {
    title: 'История операций',
    routeName: Screens.VolunteersServiceExchangeHistory,
    webRoute: Routes.volunteersServiceExchangeHistory,
  },
];

export const VolunteersServiceExchangeHistoryScreen: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMolodayaArcticaData());
  }, []);

  const molodayaArcticaData = useSelector(molodayaArcticaSelector);
  const isLoading = useSelector(molodayaArcticaLoadingSelector);
  const isDesktop = useIsDesktop();
  const [data, showMore, allShown] = usePartialList(molodayaArcticaData ?? null, defaults.partialListSizeWithButton);

  const styles = useStyles(({theme, deviceSize, mediaOnly}) => {
    return {
      screen: {
        backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      },
      sectionTitle: {
        marginTop: 38,
        marginBottom: 32,
      },
      sectionContainer: {
        overflow: 'hidden',
        marginTop: 30,
        ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      },
      contentContainer: {
        paddingBottom: theme.screen.bottomOffset,
      },
      loadMoreWrapper: {
        marginTop: 10,
        alignItems: 'center',
        width: 'auto',
        maxWidth: 900,
      },
      loadMoreButton: {
        borderWidth: 0,
        width: 180,
      },
    };
  });

  return (
    <Screen style={styles.screen}>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <Breadcrumbs style={{flex: undefined}} routes={routes} />
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text testID='transport-app-id' type='h2' style={styles.sectionTitle}>
              История операций по обмену баллов
            </Text>
          </ResponsiveView>
          <LoadableContent style={styles.contentContainer} loading={isLoading}>
            {isDesktop ? <DesktopView data={data} /> : <MobileView data={data} />}
            {!allShown && (
              <View style={styles.loadMoreWrapper}>
                <Button
                  id='notifications-more'
                  onPress={showMore}
                  style={styles.loadMoreButton}
                  text='Показать еще'
                  type='transparent'
                  icon={images.ChevronDown}
                  iconProps={{width: 24, height: 24}}
                />
              </View>
            )}
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
